"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Input_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Input"));
var Modal_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Modal"));
var Paginator_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Paginator"));
var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));
var Table_1 = require("@sportnet/ui/lib/Table");
var utilities_1 = require("@sportnet/ui/lib/utilities");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_2 = require("@sportnet/utilities");
var CoreApi_1 = tslib_1.__importDefault(require("../../../api/CoreApi"));
var setupApis_1 = require("../../../api/setupApis");
var detail_1 = tslib_1.__importDefault(require("./detail"));
setupApis_1.setupCoreApi();
var UntypedModal = Modal_1["default"];
var UsersList = function (props) {
    var _a = props.data, data = _a === void 0 ? {} : _a, renderEmpty = props.renderEmpty;
    if (renderEmpty && !utilities_2.getProp(data, ['filters', 'affiliationCategory'])) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('usersList'));
    }
    var _b = react_1["default"].useState([]), users = _b[0], setUsers = _b[1];
    var _c = react_1["default"].useState(0), total = _c[0], setTotal = _c[1];
    var _d = react_1["default"].useState(0), currentOffset = _d[0], setCurrentOffset = _d[1];
    var _e = react_1["default"].useState(false), isFetching = _e[0], setIsFetching = _e[1];
    var _f = react_1["default"].useState(null), activePersonId = _f[0], setActivePersonId = _f[1];
    var _g = react_1["default"].useState(''), q = _g[0], setQ = _g[1];
    var _h = react_1["default"].useState(0), offset = _h[0], setOffset = _h[1];
    react_1["default"].useEffect(function () {
        var id = (window.location.hash || '').replace('#userId=', '');
        if (id && id.match(/^[0-9a-fA-F]{24}$/)) {
            // it's an ObjectID
            setActivePersonId(id);
        }
        setUsers(utilities_2.getProp(data, ['data', 'users'], []));
        setTotal(utilities_2.getProp(data, ['data', 'total'], 0));
    }, []);
    var togglePersonModal = function (id) {
        if (id === void 0) { id = null; }
        if (history.pushState) {
            history.pushState(null, '', id ? "#userId=" + id : "" + location.pathname + location.search);
        }
        else {
            location.hash = id ? "#userId=" + id : '';
        }
        setActivePersonId(id);
    };
    react_1["default"].useEffect(function () {
        getUsers(true);
    }, [q]);
    react_1["default"].useEffect(function () {
        getUsers();
    }, [offset]);
    var getUsers = function (resetOffset) {
        if (resetOffset === void 0) { resetOffset = false; }
        return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsFetching(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, CoreApi_1["default"].organizationPPOUsers(utilities_2.getProp(data, ['appSpace']), tslib_1.__assign(tslib_1.__assign({}, utilities_2.getProp(data, ['filters'], {})), { offset: resetOffset ? 0 : offset, q: q }))];
                    case 2:
                        res = _a.sent();
                        setCurrentOffset(res.offset || 0);
                        setUsers(res.users || []);
                        setTotal(res.total || 0);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        alert(utilities_1.__('Nepodarilo sa získať zoznam používateľov'));
                        return [3 /*break*/, 5];
                    case 4:
                        setIsFetching(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var setQuery = react_1["default"].useMemo(function () {
        return utilities_1.debounce(function (e) {
            setQ(e);
        }, 300);
    }, []);
    var setNewOffset = function (e) {
        setOffset(e);
    };
    return (react_1["default"].createElement(Segment_1["default"], { raised: true },
        react_1["default"].createElement(Input_1["default"], { onChange: function (e) {
                setQuery(e.target.value);
            }, placeholder: utilities_1.__('Zadajte meno...') },
            react_1["default"].createElement(Input_1["default"].Icon, { name: "search" }),
            react_1["default"].createElement("input", null)),
        react_1["default"].createElement("br", null),
        react_1["default"].createElement(Table_1.Table, null,
            react_1["default"].createElement(Table_1.Thead, null,
                react_1["default"].createElement(Table_1.Tr, null,
                    react_1["default"].createElement(Table_1.Th, null, utilities_1.__('Meno a priezvisko')),
                    react_1["default"].createElement(Table_1.Th, null, utilities_1.__('Rok narodenia')))),
            react_1["default"].createElement(Table_1.Tbody, null, users.map(function (u) { return (react_1["default"].createElement(Table_1.Tr, { key: u._id, onClick: function () {
                    togglePersonModal(u._id);
                } },
                react_1["default"].createElement(Table_1.Td, null, utilities_2.formatUserName(u)),
                react_1["default"].createElement(Table_1.Td, null, u.birthyear))); }))),
        react_1["default"].createElement(Paginator_1["default"], { total: total, offset: currentOffset, loading: isFetching, onChangeOffset: setNewOffset, limit: utilities_2.getProp(data, ['data', 'limit'], 0) }),
        !!activePersonId && (react_1["default"].createElement(UntypedModal, { handleClose: function () { return togglePersonModal(); }, isOpen: !!activePersonId },
            react_1["default"].createElement(Modal_1.ModalContent, null, activePersonId && (react_1["default"].createElement(detail_1["default"], { id: activePersonId, handleClose: togglePersonModal, appSpace: utilities_2.getProp(data, ['appSpace'], '') })))))));
};
exports["default"] = UsersList;
